import { DataBean } from "../../DataBean";


export class BodyComponent extends DataBean {


    public async getBodyComponentCatalog(type:any,regexStr:any,page:any,recordsPerPage:any): Promise<any> {
        return this.getCustomService("QuickDataERPCore", "com.advantage.shared.Report_getBodyComponentCatalog_Number_String_Number_Number", [type,regexStr,page,recordsPerPage]);
    }


}